export const ENABLE_MV3 = true;
export const PUSH_NOTIFICATIONS_SERVICE_URL = 'https://push.api.cx.metamask.io';

export const FIREBASE_API_KEY = '';
export const FIREBASE_AUTH_DOMAIN = '';
export const FIREBASE_STORAGE_BUCKET = '';
export const FIREBASE_PROJECT_ID = '';
export const FIREBASE_MESSAGING_SENDER_ID = '';
export const FIREBASE_APP_ID = '';
export const FIREBASE_MEASUREMENT_ID = '';
export const VAPID_KEY = '';
